import React from 'react'; // Ensure React is imported
import './StudentCard.css';
import Barcode from 'react-barcode';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';

const StudentCard = () => {
  return (
    <div className="container">
        <CurrentTime/>
        <DynamicIsland/>
        <Back/>

        <div className="student-card" style={{backgroundImage: "url('./img/towson-background-1.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat"}}>
  <div className="student-info">
    <img src="./img/john-doe.png" alt="Student profile picture" className="student-photo" />
    <div className="student-details">
    <h2 className="student-name">John Doe</h2>
    <p className="student-id">ID: 0000000</p>
    <p className="student-status">Student</p>
    </div>
  </div>
  <div className="barcode-container">
    <Barcode 
      value="0000000" 
      format="CODE128" 
      width={2} 
      height={50} 
      displayValue={false} 
    />
  </div>
</div>
    <div className="information">
        <h4>Need a physical card? Contact the <a href="mailto:onecard@towson.edu">OneCard Office.</a></h4>
    </div>

    </div>
  );
};

export default StudentCard;
